import { render, staticRenderFns } from "./ThePersonalOrders.vue?vue&type=template&id=0a1f965a&"
import script from "./ThePersonalOrders.vue?vue&type=script&lang=js&"
export * from "./ThePersonalOrders.vue?vue&type=script&lang=js&"
import style0 from "./ThePersonalOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports